/* ============
 * Getters for the auth module
 * ============
 *
 * The getters that are available on the
 * auth module.
 */
export default {
  authenticated (state) {
    const expiresAt = JSON.parse(state.expiresAt || '[]')
    return new Date().getTime() < expiresAt
  }
}



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/getters.js